/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ObservationstypeGroupsObservationTypeGroup from './ObservationstypeGroupsObservationTypeGroup';

/**
 * The ObservationsTypeGroupsBody model module.
 * @module model/ObservationsTypeGroupsBody
 * @version v0.3
 */
export default class ObservationsTypeGroupsBody {
  /**
   * Constructs a new <code>ObservationsTypeGroupsBody</code>.
   * @alias module:model/ObservationsTypeGroupsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ObservationsTypeGroupsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ObservationsTypeGroupsBody} obj Optional instance to populate.
   * @return {module:model/ObservationsTypeGroupsBody} The populated <code>ObservationsTypeGroupsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ObservationsTypeGroupsBody();
      if (data.hasOwnProperty('observation_type_group'))
        obj.observationTypeGroup = ObservationstypeGroupsObservationTypeGroup.constructFromObject(data['observation_type_group']);
    }
    return obj;
  }
}

/**
 * @member {module:model/ObservationstypeGroupsObservationTypeGroup} observationTypeGroup
 */
ObservationsTypeGroupsBody.prototype.observationTypeGroup = undefined;

